import { render, staticRenderFns } from "./Or.vue?vue&type=template&id=3d431906&"
import script from "./Or.vue?vue&type=script&lang=ts&"
export * from "./Or.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports